<template>
	<video class="bg_video" playsinline autoplay muted loop poster='../assets/videos/Hubblejwstrender_020224.mp4'>
		<source :src='require("../assets/videos/Hubblejwstrender_020224.mp4")' type='video/mp4'>
	</video>
	<div class="main" @click="start">
		<div class="title-container">
			<transition name="slide-text--left" appear>
				<h1>Hubble</h1>
			</transition>
			<transition name="slide-text--right" appear>
				<h1>JWST</h1>
			</transition>
		</div>
			<div class="footer-container">
				<transition name="slide-text--left" appear>
					<div class="side-text--left">
						Hubble<br/>
						Space Telescope/<br/>
						telescopio espacial
					</div>
				</transition>
				<transition name="slide-footer" appear>
					<div class="middle-text">
						COMPARE / COMPARAR
					</div>
				</transition>
				<transition name="slide-text--right" appear>
					<div class="side-text--right">
						James Webb<br/>
						Space Telescope/<br/>
						telescopio espacial
					</div>
				</transition>
			</div>
	</div>
</template>

<script>
import { store } from '../store.js'

export default {
	name: 'StartPage',
	props: {},
	data() {
		return {
		}
	},
	mounted() {
	},
	methods: {
		start() {
			console.log('start')
			store.showStartPage = false
  			store.showSliderPage = true
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.main {
		position: fixed;
  		bottom: 0;
		width: 100%;
		height: 100%;
	}

	.bg_video {
		position: fixed;
		right: 0;
		bottom: 0;
		min-width: 100%;
		min-height: 100%;
		max-width: 100%;
	}

	.title-container {
		width: 100%;
		height: 85%;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: space-evenly;
	}

	.title-container h1 {
		margin-top: 3rem;
		font-family: Magazine-Bold;
		font-size: var(--font-size-six);
		color: var(--white-transparent);
	}

	.footer-container {
		height: 15%;
		width: 100%;
		display: grid;
		grid-template-columns: 0.5fr 1fr 0.5fr;
	}

	.middle-text {
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: Magazine-Regular;
		font-size: 3.221rem;
	}

	.side-text--left {
		text-align: left;
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: Magazine-Regular;
		font-size: var(--font-size-two);
	}

	.side-text--right {
		text-align: right;
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: Magazine-Regular;
		font-size: var(--font-size-two);
	}
</style>
